<template>
    <div
        aria-hidden="true"
        :class="expandToPageEdges ? '-mx-3 w-[calc(100%+1.5rem)] md:-mx-5 md:w-[calc(100%+2.5rem)]' : ''"
    >
        <div class="flex gap-3 overflow-hidden justify-start">
            <div
                v-for="i in count"
                :key="i"
                class="h-[210px] w-[168px] shrink-0 rounded-xl bg-[rgba(28,28,30,0.8)] animate-pulse lg:h-[280px] lg:w-[224px]"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        count?: number
        expandToPageEdges?: boolean
    }>(),
    {
        count: 8,
        expandToPageEdges: false,
    }
)
</script>
